import { kebabCase } from 'lodash'

/**
 * Generates a kebab-case alert identifier from a string.
 *
 * @remarks
 * Converts the input string to kebab-case and truncates it to a maximum of 500 characters.
 * Used for creating unique, consistent alert IDs for storage and tracking.
 *
 * @param str - The input string to convert.
 * @returns The kebab-case string, truncated to 500 characters.
 */
export function createAlertId(str: string): string {
  return kebabCase(str).substring(0, 500)
}
